import React from 'react'
import MainHeader from '../../components/MainHeader/MainHeader'

export default function PageNotFound(props) {
    return (
        <>
            <MainHeader />
            <div className='container'>
                    <div className="s-flex-center" style={{flexDirection:"column"}}>
                        <h2 className='s-grey s-mt'>
                            Page Not Found - 404
                        </h2><br />
                        <button className="back-home s-mb" onClick={()=>props.history.push("/")}>Back Home</button>
                    </div>
            </div>
        </>
    )
}
